<template>
  <div
    id="allDownloadPanel"
    class="all-download-panel"
    :class="visible ? 'show-panel' : ''"
    :data-position="domPosition"
  >
    <ul class="all-download-con" :style="{ width: isInWindows ? 384 : 192 }">
      <li class="list">
        <h4 class="title">
          <em class="iconfont icon-title y-icon--00237 qd-icon"></em>
          手机版
        </h4>
        <p class="desc">扫码下载手机APP</p>
        <div
          class="download-panel"
          data-l1="1"
          data-type="dl"
          data-is_daoliu="1"
        >
          <DdlQrcode
            :dl-track="qrEid"
            :show="visible"
            :width="108"
            :book-id="bookId"
            :chapter-id="chapterId"
          ></DdlQrcode>
        </div>
        <p class="txt">扫码下载起点读书APP</p>
        <p class="txt red">新设备新账号立享海量作品免费读</p>
      </li>
      <li
        id="downloadWin"
        class="list"
        :class="isInWindows ? '' : 'dn'"
        :data-iswin="isInWindows"
        :data-eid="downloadEid"
      >
        <h4 class="title">
          <em class="icon-windows iconfont">&#xe907;</em>
          桌面版
        </h4>
        <p class="desc">适合Windows系统设备</p>
        <div class="download-panel">
          <img
            class="qd-img"
            src="https://imgservices-1252317822.image.myqcloud.com/coco/s11022022/43dddf20.il61if.svg"
            alt=""
          />
          <a
            class="download-desk jsDownloadDesk"
            data-l7="1"
            :data-eid="downloadEid"
            href="https://down.pc.yyb.qq.com/packing/3c25016cde98caefd1e7c1d7db2886ed/com.qidian.QDReader_2500100000_installer.exe"
            rel="nofollow"
          >
            立即下载
          </a>
          <p class="download-hover-tips">
            由腾讯应用宝移动引擎提供电脑版体验能力
          </p>
        </div>
        <p class="txt">点击下载起点读书桌面版</p>
        <p class="txt">获取更丝滑的阅读体验</p>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
/**
 * 下载面板：详情页 / 阅读页内嵌的「扫码下 App + 桌面版下载」弹窗。
 *
 * 使用方式：
 *   - 父级用 v-on:mouseenter / v-on:mouseleave 控制 visible
 *   - props.bookId / chapterId 透传给 DdlQrcode 用于生成归因二维码
 *
 * 移植自 metrix 老站 pc/src/common/components/Download.vue。
 * 矩阵站 v2 仅在详情页 / 阅读页 hover 引导下 App 时展示。
 */
import { withDefaults } from 'vue'
import DdlQrcode from './DdlQrcode.vue'

interface Props {
  visible: boolean
  isInWindows?: boolean
  domPosition?: 'top' | 'bottom' | 'left' | 'right' | 'center'
  downloadEid?: string
  qrEid?: string
  bookId?: number | string
  chapterId?: string
}

withDefaults(defineProps<Props>(), {
  domPosition: 'bottom',
  isInWindows: false,
  downloadEid: '',
  qrEid: '',
  visible: false,
  bookId: 0,
  chapterId: '',
})
</script>

<style lang="scss">
.all-download-panel {
  display: block;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  z-index: 5;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  transition: all 0.1s;
  will-change: transform;

  &.show-panel {
    opacity: 1;
    visibility: visible;

    &::before {
      display: none;
    }

    .all-download-con {
      margin: auto;
    }
  }

  &[data-position='center'] {
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  &[data-position='top'] {
    top: 10px;
    left: 50%;
    transform: translateY(-100%) translateX(-50%);
  }

  &[data-position='top']::before {
    content: '';
    display: block;
    top: auto;
    bottom: -8px;
    border-width: 8px 8px 0 8px;
    border-color: #fff transparent transparent transparent;
  }

  &[data-position='left'] {
    left: -10px;
    top: 50%;
    transform: translateY(-50%) translateX(-100%);
  }

  &[data-position='left']::before {
    content: '';
    display: block;
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
    left: auto;
    right: -8px;
    border-width: 8px 0 8px 8px;
    border-color: transparent transparent transparent #fff;
  }

  &[data-position='right'] {
    right: -10px;
    top: 50%;
    transform: translateY(-50%) translateX(100%);
  }

  &[data-position='right']::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-width: 8px 8px 8px 0;
    border-color: transparent #fff transparent transparent;
  }

  &[data-position='bottom'] {
    bottom: -10px;
    left: 50%;
    transform: translateY(100%) translateX(-50%);
  }

  &[data-position='bottom']::before {
    position: absolute;
    content: '';
    display: block;
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent #fff transparent;
    top: -8px;
    left: 50%;
    margin-left: -8px;
  }

  .all-download-con {
    .list {
      float: left;
      padding: 24px 0;
      min-width: 192px;

      & + .list {
        box-shadow: -17px 0 0 -16px rgba(0, 0, 0, 0.08);
      }

      &.dn {
        display: none;
      }
    }

    .title {
      font-size: 16px;
      line-height: 24px;
      color: #191919;
      font-weight: 600;
      text-align: center;

      em.iconfont {
        font-weight: 400;
      }
    }

    .desc {
      font-size: 12px;
      line-height: 14px;
      color: #808080;
      text-align: center;
      margin-top: 5px;
      transform: scale(0.833);
    }

    .download-panel {
      position: relative;
      width: 116px;
      height: 116px;
      margin: 12px auto;
      text-align: center;
    }

    .icon-title,
    .icon-windows {
      display: inline-block;
      font-size: 20px;
      vertical-align: bottom;
      margin: auto !important;
      padding-right: 0 !important;
      margin-right: 4px;
    }

    .txt {
      font-size: 12px;
      line-height: 20px;
      color: #808080;
      text-align: center;
    }

    .red {
      color: #e5353e;
    }

    .qd-img {
      display: block;
      width: 68px;
      height: 68px;
      margin: 4px auto 0;
    }

    .download-desk {
      float: none !important;
      height: initial !important;
      color: #e5353e !important;
      background-color: transparent !important;
      margin-top: 12px;
      margin-left: 0;
      display: inline-block;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px !important;
      padding: 6px 10px;
      border: 1px solid #e5353e !important;
      border-radius: 6px;
      box-sizing: border-box;

      &:hover {
        background-color: #ffe5e7 !important;

        & + .download-hover-tips {
          opacity: 1;
          visibility: visible;
        }
      }
    }

    .download-hover-tips {
      position: absolute;
      opacity: 0;
      visibility: hidden;
      bottom: 46px;
      font-size: 14px;
      line-height: 22px;
      color: #fff;
      background-color: #333;
      padding: 7px 0;
      border-radius: 8px;
      width: 290px;
      text-align: center;
      left: -98px;

      &::after {
        position: absolute;
        content: '';
        border-style: solid;
        border-width: 8px 8px 0 8px;
        border-color: #333 transparent transparent transparent;
        left: 50%;
        bottom: -8px;
        margin-left: 4px;
      }
    }
  }
}
</style>
